import { Reveal } from "../shared/Reveal";

// Reusable editorial section heading (eyebrow + serif heading + intro).
export default function SectionHeading({ eyebrow, heading, intro, align = "left", className = "" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {eyebrow && <span className="eyebrow mb-4">{eyebrow}</span>}
      <h2 className="font-serif font-medium text-primary text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-balance">
        {heading}
      </h2>
      {intro && <p className="mt-6 text-lg text-secondary-foreground font-light leading-relaxed">{intro}</p>}
    </Reveal>
  );
}
